import m from 'mithril';

const Chart = require('chart.js');


export default {
  onupdate({ state, attrs }) {
    if (state.chart) {
      state.chart.destroy();
    }
    const ctx = document.getElementById('myChart').getContext('2d');
    const myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: attrs.labels,
        datasets: [{
          label: attrs.label,
          data: attrs.data,
          backgroundColor: attrs.data.map(x => '#242939'),
          borderWidth: 1,
        }],
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
        animation: {
          duration: 0,
        },
      },
    });
    state.chart = myChart;
  },
  view() {
    return m('div', {
      style: {
        height: '264px',
      },
    }, m("canvas[id='myChart'][width='100%']"));
  },
};
